module.exports = __webpack_public_path__ + "static/Bittrex-f2ce9ca3f080eee6f971e5829fa2a41c.png";